import { render, staticRenderFns } from "./goodsSelect.vue?vue&type=template&id=4af98161&scoped=true"
import script from "./goodsSelect.vue?vue&type=script&lang=js"
export * from "./goodsSelect.vue?vue&type=script&lang=js"
import style0 from "./goodsSelect.vue?vue&type=style&index=0&id=4af98161&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af98161",
  null
  
)

export default component.exports